/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */
import { exists, mapValues } from './model-utils';

/**
 * 
 * @export
 * @interface CreatePlayerMobileRequestContent
 */
export interface CreatePlayerMobileRequestContent {
    /**
     * 
     * @type {string}
     * @memberof CreatePlayerMobileRequestContent
     */
    mobile: string;
}


/**
 * Check if a given object implements the CreatePlayerMobileRequestContent interface.
 */
export function instanceOfCreatePlayerMobileRequestContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "mobile" in value;
    return isInstance;
}

export function CreatePlayerMobileRequestContentFromJSON(json: any): CreatePlayerMobileRequestContent {
    return CreatePlayerMobileRequestContentFromJSONTyped(json, false);
}

export function CreatePlayerMobileRequestContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreatePlayerMobileRequestContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'mobile': json['mobile'],
    };
}

export function CreatePlayerMobileRequestContentToJSON(value?: CreatePlayerMobileRequestContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'mobile': value.mobile,
    };
}

